export default "__VITE_ASSET__DvL4os_D__"